// create the module before importing the sub-resources, as they don't each
// make their own angular module because reasons
let module = angular.module('app.services', []);

// The act of importing these actually registers them with the angular module
// from above, so we're good to go at this point.
require('./auth_service');
require('./broadcast_service');
require('./config');
require('./elasticsearch_service');
require('./feature_billing_service');
require('./rpc');
require('./stats_service');

export default module;



// WEBPACK FOOTER //
// ./services/index.js